import axios from "axios";

export default function ScheduleStatusesService() {

  return axios({
    method: 'get',
    url: process.env.REACT_APP_API_HOST + "/schedule_status",
    params: {},
    headers: {'Authorization': 'Bearer ' + localStorage.getItem("userToken"), 'App-Network': localStorage.getItem("networkId")}
  });
}
